import * as React from 'react';
import {useCallback, useMemo, useState} from 'react';
import useData from "../hooks/useData";
import {useAppSelector} from "../store/hooks";
import DetailPage from "../components/DetailPage";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {setOrderDetailId} from "../store/ApplicationSlice";
import {useDispatch} from "react-redux";
import {DashboardsDiv} from "../ic3/DashboardsDiv";
import Box from "@mui/material/Box";
import {DashboardsDivContext, DashboardsDivReactContext} from "../ic3/DashboardsDivContext";
import {IReporting} from "@ic3/reporting-api-embedded";

export default function PopupOrderDetail() {

    const orderID = useAppSelector(state => state.application.orderDetailId);
    const data = useData(`getOrderDetails/` + orderID);
    const dispatch = useDispatch();

    const [_repPurchaser, setRepPurchaser] = useState<IReporting>();
    const [_repSupplier, _setRepSupplier] = useState<IReporting>();

    const handleClose = useCallback(() => {
        dispatch(setOrderDetailId(undefined))
    }, [dispatch]);

    const context = useMemo(() => new DashboardsDivContext({
        customHeaders: "dashboards"
    }), []);

    const paramPoNumber = useMemo(() => {

        const poId = data?.['id'];

        if (poId == null) {
            return undefined;
        }

        return [{
            channelName: "po-line",
            value: {
                uniqueName: `[Po Number].[Po Number].[Po Number].&[${poId}]`,
                name: data?.['poNumber'] ?? "",
                caption: data?.['poNumber'] ?? ""
            }
        }];
    }, [data]);

    return <Dialog
        open={orderID != null}
        onClose={handleClose}
        maxWidth={"md"}
        fullWidth
    >
        <DialogTitle sx={{m: 0, p: 2}}>
            Order Details : {data?.['poNumber']}
        </DialogTitle>
        <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon/>
        </IconButton>
        <DialogContent dividers>
            <DashboardsDivReactContext.Provider value={context}>
                <Box display={"flex"} flexDirection={"column"} gap={3}>
                    <Box height={260}>
                        {
                            paramPoNumber && <DashboardsDiv className={"ic3-PO-detail"} uid={"ic3-PO-detail"}
                                       dashboardPath={"shared:/PO Details"} params={paramPoNumber}
                                       autoResize={false}
                                       setReporting={setRepPurchaser}/>
                        }
                    </Box>
                    <DetailPage data={data} title={data?.['poNumber'] ?? ""}/>
                </Box>
            </DashboardsDivReactContext.Provider>
        </DialogContent>
    </Dialog>
}
